// extracted by mini-css-extract-plugin
export default {"actionContainer":"styles_actionContainer__BZuiy"};